import { render, staticRenderFns } from "./FormPictureLocaleDeprecated.vue?vue&type=template&id=65befd1c&scoped=true&"
import script from "./FormPictureLocaleDeprecated.vue?vue&type=script&lang=js&"
export * from "./FormPictureLocaleDeprecated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65befd1c",
  null
  
)

export default component.exports